import { useNavigate } from "react-router-dom";
import { UserRole } from "src/models";
import { useAppSelector } from "src/redux/hooks";
import { getSettingsPageSubscriptionTab } from "src/utility/SubscriptionProvider";

export function UpgradeLink() {
  const user = useAppSelector((state) => state.user);
  const navigate = useNavigate();

  if (user.role === UserRole.Admin) {
    return (
      <a
        className="upgrade-link"
        onClick={() => {
          navigate("/settings?defaultTab=" + getSettingsPageSubscriptionTab());
        }}
      >
        Upgrade
      </a>
    );
  } else {
    return "Upgrade";
  }
}
